"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInput = exports.Root = exports.MapPin = exports.ClearButton = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  padding: theme.spacing(0, 3, 4),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(0, 6, 4)
  },
  [`.${_mui.inputBaseClasses.input}`]: {
    padding: theme.spacing(2, 3)
  },
  [`.${_mui.inputBaseClasses.root}`]: {
    background: theme.palette.grey[100]
  }
}));
const SearchInput = exports.SearchInput = (0, _mui.styled)(_mui.TextField)(({
  theme
}) => ({
  display: 'flex',
  input: {
    cursor: 'pointer',
    '&::placeholder': {
      color: theme.palette.grey.A700
    }
  },
  [theme.breakpoints.up('md')]: {
    input: {
      cursor: 'text',
      height: 24
    }
  }
}));
const ClearButton = exports.ClearButton = (0, _mui.styled)(_icons.Clear)({
  cursor: 'pointer'
});
const MapPin = exports.MapPin = (0, _mui.styled)(_icons.MapPin)(({
  theme
}) => ({
  marginRight: 14,
  color: theme.palette.text.primary,
  [theme.breakpoints.down('sm')]: {
    marginRight: 6
  }
}));